// Module
var code = "<div bar-chart=barChartInput is-already-sorted=true></div> ";
// Exports
module.exports = code;